var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = (scopeName, key) => {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = (scope, key) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key) => {
	var versions = scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingleton = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	return get(scope[key][version]);
};
var getSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) typeof console !== "undefined" && console.warn && console.warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = (scope, key, requiredVersion) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = (scope, scopeName, key, requiredVersion) => {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warnInvalidVersion = (scope, scopeName, key, requiredVersion) => {
	typeof console !== "undefined" && console.warn && console.warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var init = (fn) => (function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
});

var load = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	535: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/icon", [4,6,5,0], () => (__webpack_require__.e(4943).then(() => (() => (__webpack_require__(64729))))))),
	4501: () => (loadSingletonVersionCheckFallback("default", "@clr/angular", [4,13,18,3], () => (__webpack_require__.e(355).then(() => (() => (__webpack_require__(64602))))))),
	5454: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/core", [4,15,2,10], () => (__webpack_require__.e(9397).then(() => (() => (__webpack_require__(9397))))))),
	5812: () => (loadSingletonVersionCheckFallback("default", "@angular/forms", [4,15,2,10], () => (__webpack_require__.e(487).then(() => (() => (__webpack_require__(70441))))))),
	8655: () => (loadSingletonVersionCheckFallback("default", "@eseye/ngx-dashboard", [4,1,1,118], () => (__webpack_require__.e(4921).then(() => (() => (__webpack_require__(64921))))))),
	11489: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/alert", [4,6,5,0], () => (__webpack_require__.e(1772).then(() => (() => (__webpack_require__(54818))))))),
	22418: () => (loadSingletonVersionCheckFallback("default", "@eseye/ngx-shared", [4,1,0,60], () => (__webpack_require__.e(7953).then(() => (() => (__webpack_require__(87953))))))),
	23974: () => (loadSingletonVersionCheckFallback("default", "@ngxs/store", [4,3,8,2], () => (__webpack_require__.e(4236).then(() => (() => (__webpack_require__(27212))))))),
	33439: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/button", [4,6,5,0], () => (__webpack_require__.e(8125).then(() => (() => (__webpack_require__(41682))))))),
	33469: () => (loadSingletonVersionCheckFallback("default", "@angular/router", [4,15,2,10], () => (__webpack_require__.e(2939).then(() => (() => (__webpack_require__(22079))))))),
	34323: () => (loadSingletonVersionCheckFallback("default", "@eseye/ngx-auth", [4,1,0,118], () => (__webpack_require__.e(8616).then(() => (() => (__webpack_require__(98616))))))),
	41171: () => (loadSingletonVersionCheckFallback("default", "@angular/common/http", [4,15,2,10], () => (__webpack_require__.e(8568).then(() => (() => (__webpack_require__(53705))))))),
	48678: () => (loadSingletonVersionCheckFallback("default", "@cds/core/icon", [4,6,5,0], () => (__webpack_require__.e(3646).then(() => (() => (__webpack_require__(16209))))))),
	48850: () => (loadSingletonVersionCheckFallback("default", "@angular/common", [4,15,2,10], () => (__webpack_require__.e(4008).then(() => (() => (__webpack_require__(81381))))))),
	72668: () => (loadSingletonVersionCheckFallback("default", "devextreme-angular", [4,23,2,4], () => (__webpack_require__.e(8679).then(() => (() => (__webpack_require__(24934))))))),
	75243: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/checkbox", [4,6,5,0], () => (__webpack_require__.e(1117).then(() => (() => (__webpack_require__(43703))))))),
	85967: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/progress-circle", [4,6,5,0], () => (__webpack_require__.e(8172).then(() => (() => (__webpack_require__(98449))))))),
	86699: () => (loadSingletonVersionCheckFallback("default", "@cds/core/button/register.js", [4,6,5,0], () => (__webpack_require__.e(8898).then(() => (() => (__webpack_require__(58898))))))),
	87257: () => (loadSingletonVersionCheckFallback("default", "@cds/angular", [4,6,5,0], () => (__webpack_require__.e(4678).then(() => (() => (__webpack_require__(66288))))))),
	95834: () => (loadSingletonVersionCheckFallback("default", "@cds/core/icon/register.js", [4,6,5,0], () => (__webpack_require__.e(9910).then(() => (() => (__webpack_require__(49910))))))),
	96141: () => (loadSingletonVersionCheckFallback("default", "@ngxs/store/operators", [4,3,8,2], () => (__webpack_require__.e(6366).then(() => (() => (__webpack_require__(16366))))))),
	96795: () => (loadSingletonVersionCheckFallback("default", "@ngneat/transloco", [4,4,2,7], () => (__webpack_require__.e(903).then(() => (() => (__webpack_require__(85043))))))),
	59571: () => (loadSingletonVersionCheckFallback("default", "@cds/core/accordion/register.js", [4,6,5,0], () => (__webpack_require__.e(4422).then(() => (() => (__webpack_require__(44422))))))),
	95087: () => (loadSingletonVersionCheckFallback("default", "@cds/core/alert/register.js", [4,6,5,0], () => (__webpack_require__.e(7331).then(() => (() => (__webpack_require__(87331))))))),
	28286: () => (loadSingletonVersionCheckFallback("default", "@cds/core/badge/register.js", [4,6,5,0], () => (__webpack_require__.e(1798).then(() => (() => (__webpack_require__(31798))))))),
	89343: () => (loadSingletonVersionCheckFallback("default", "@cds/core/breadcrumb/register.js", [4,6,5,0], () => (__webpack_require__.e(8177).then(() => (() => (__webpack_require__(28177))))))),
	70344: () => (loadSingletonVersionCheckFallback("default", "@cds/core/button-action/register.js", [4,6,5,0], () => (__webpack_require__.e(7707).then(() => (() => (__webpack_require__(67707))))))),
	57966: () => (loadSingletonVersionCheckFallback("default", "@cds/core/button-expand/register.js", [4,6,5,0], () => (__webpack_require__.e(4543).then(() => (() => (__webpack_require__(84543))))))),
	57660: () => (loadSingletonVersionCheckFallback("default", "@cds/core/button-handle/register.js", [4,6,5,0], () => (__webpack_require__.e(6938).then(() => (() => (__webpack_require__(46938))))))),
	24742: () => (loadSingletonVersionCheckFallback("default", "@cds/core/button-inline/register.js", [4,6,5,0], () => (__webpack_require__.e(8667).then(() => (() => (__webpack_require__(10394))))))),
	73041: () => (loadSingletonVersionCheckFallback("default", "@cds/core/button-sort/register.js", [4,6,5,0], () => (__webpack_require__.e(619).then(() => (() => (__webpack_require__(619))))))),
	54642: () => (loadSingletonVersionCheckFallback("default", "@cds/core/card/register.js", [4,6,5,0], () => (__webpack_require__.e(8111).then(() => (() => (__webpack_require__(68111))))))),
	14113: () => (loadSingletonVersionCheckFallback("default", "@cds/core/checkbox/register.js", [4,6,5,0], () => (__webpack_require__.e(3095).then(() => (() => (__webpack_require__(93095))))))),
	67694: () => (loadSingletonVersionCheckFallback("default", "@cds/core/datalist/register.js", [4,6,5,0], () => (__webpack_require__.e(7695).then(() => (() => (__webpack_require__(57695))))))),
	42262: () => (loadSingletonVersionCheckFallback("default", "@cds/core/date/register.js", [4,6,5,0], () => (__webpack_require__.e(4657).then(() => (() => (__webpack_require__(4657))))))),
	2772: () => (loadSingletonVersionCheckFallback("default", "@cds/core/divider/register.js", [4,6,5,0], () => (__webpack_require__.e(7959).then(() => (() => (__webpack_require__(77959))))))),
	11278: () => (loadSingletonVersionCheckFallback("default", "@cds/core/dropdown/register.js", [4,6,5,0], () => (__webpack_require__.e(3905).then(() => (() => (__webpack_require__(23905))))))),
	4414: () => (loadSingletonVersionCheckFallback("default", "@cds/core/file/register.js", [4,6,5,0], () => (__webpack_require__.e(1032).then(() => (() => (__webpack_require__(41032))))))),
	75989: () => (loadSingletonVersionCheckFallback("default", "@cds/core/forms/register.js", [4,6,5,0], () => (__webpack_require__.e(5292).then(() => (() => (__webpack_require__(5292))))))),
	44585: () => (loadSingletonVersionCheckFallback("default", "@cds/core/grid/register.js", [4,6,5,0], () => (__webpack_require__.e(2094).then(() => (() => (__webpack_require__(22094))))))),
	27771: () => (loadSingletonVersionCheckFallback("default", "@cds/core/input/register.js", [4,6,5,0], () => (__webpack_require__.e(479).then(() => (() => (__webpack_require__(40479))))))),
	19941: () => (loadSingletonVersionCheckFallback("default", "@cds/core/internal-components/close-button/register.js", [4,6,5,0], () => (__webpack_require__.e(890).then(() => (() => (__webpack_require__(30890))))))),
	53209: () => (loadSingletonVersionCheckFallback("default", "@cds/core/internal-components/overlay/register.js", [4,6,5,0], () => (__webpack_require__.e(2672).then(() => (() => (__webpack_require__(92672))))))),
	68686: () => (loadSingletonVersionCheckFallback("default", "@cds/core/internal-components/panel/register.js", [4,6,5,0], () => (__webpack_require__.e(4034).then(() => (() => (__webpack_require__(74034))))))),
	10439: () => (loadSingletonVersionCheckFallback("default", "@cds/core/internal-components/popup/register.js", [4,6,5,0], () => (__webpack_require__.e(5646).then(() => (() => (__webpack_require__(75646))))))),
	26246: () => (loadSingletonVersionCheckFallback("default", "@cds/core/internal-components/split-handle/register.js", [4,6,5,0], () => (__webpack_require__.e(3848).then(() => (() => (__webpack_require__(13848))))))),
	415: () => (loadSingletonVersionCheckFallback("default", "@cds/core/internal-components/visual-checkbox/register.js", [4,6,5,0], () => (__webpack_require__.e(519).then(() => (() => (__webpack_require__(20519))))))),
	88217: () => (loadSingletonVersionCheckFallback("default", "@cds/core/modal/register.js", [4,6,5,0], () => (__webpack_require__.e(9695).then(() => (() => (__webpack_require__(39695))))))),
	92209: () => (loadSingletonVersionCheckFallback("default", "@cds/core/navigation/register.js", [4,6,5,0], () => (__webpack_require__.e(3101).then(() => (() => (__webpack_require__(23101))))))),
	58987: () => (loadSingletonVersionCheckFallback("default", "@cds/core/pagination/register.js", [4,6,5,0], () => (__webpack_require__.e(842).then(() => (() => (__webpack_require__(842))))))),
	43709: () => (loadSingletonVersionCheckFallback("default", "@cds/core/password/register.js", [4,6,5,0], () => (__webpack_require__.e(7854).then(() => (() => (__webpack_require__(27854))))))),
	25434: () => (loadSingletonVersionCheckFallback("default", "@cds/core/progress-circle/register.js", [4,6,5,0], () => (__webpack_require__.e(8856).then(() => (() => (__webpack_require__(78856))))))),
	75022: () => (loadSingletonVersionCheckFallback("default", "@cds/core/radio/register.js", [4,6,5,0], () => (__webpack_require__.e(7807).then(() => (() => (__webpack_require__(57807))))))),
	5168: () => (loadSingletonVersionCheckFallback("default", "@cds/core/range/register.js", [4,6,5,0], () => (__webpack_require__.e(9837).then(() => (() => (__webpack_require__(69837))))))),
	9420: () => (loadSingletonVersionCheckFallback("default", "@cds/core/search/register.js", [4,6,5,0], () => (__webpack_require__.e(7741).then(() => (() => (__webpack_require__(17741))))))),
	57079: () => (loadSingletonVersionCheckFallback("default", "@cds/core/select/register.js", [4,6,5,0], () => (__webpack_require__.e(9803).then(() => (() => (__webpack_require__(49803))))))),
	50768: () => (loadSingletonVersionCheckFallback("default", "@cds/core/selection-panels/checkbox/register.js", [4,6,5,0], () => (__webpack_require__.e(8963).then(() => (() => (__webpack_require__(18963))))))),
	62782: () => (loadSingletonVersionCheckFallback("default", "@cds/core/selection-panels/radio/register.js", [4,6,5,0], () => (__webpack_require__.e(863).then(() => (() => (__webpack_require__(80863))))))),
	72612: () => (loadSingletonVersionCheckFallback("default", "@cds/core/signpost/register.js", [4,6,5,0], () => (__webpack_require__.e(333).then(() => (() => (__webpack_require__(40333))))))),
	69438: () => (loadSingletonVersionCheckFallback("default", "@cds/core/tag/register.js", [4,6,5,0], () => (__webpack_require__.e(7962).then(() => (() => (__webpack_require__(77962))))))),
	63516: () => (loadSingletonVersionCheckFallback("default", "@cds/core/test-dropdown/register.js", [4,6,5,0], () => (__webpack_require__.e(5860).then(() => (() => (__webpack_require__(65860))))))),
	19898: () => (loadSingletonVersionCheckFallback("default", "@cds/core/textarea/register.js", [4,6,5,0], () => (__webpack_require__.e(1953).then(() => (() => (__webpack_require__(31953))))))),
	14614: () => (loadSingletonVersionCheckFallback("default", "@cds/core/time/register.js", [4,6,5,0], () => (__webpack_require__.e(9422).then(() => (() => (__webpack_require__(39422))))))),
	10360: () => (loadSingletonVersionCheckFallback("default", "@cds/core/toggle/register.js", [4,6,5,0], () => (__webpack_require__.e(9811).then(() => (() => (__webpack_require__(39811))))))),
	70226: () => (loadSingletonVersionCheckFallback("default", "@cds/core/tree-view/register.js", [4,6,5,0], () => (__webpack_require__.e(248).then(() => (() => (__webpack_require__(40248))))))),
	449: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/internal-components/close-button", [4,6,5,0], () => (__webpack_require__.e(3499).then(() => (() => (__webpack_require__(67446))))))),
	1344: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/radio", [4,6,5,0], () => (__webpack_require__.e(3626).then(() => (() => (__webpack_require__(73346))))))),
	2599: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/tag", [4,6,5,0], () => (__webpack_require__.e(6104).then(() => (() => (__webpack_require__(11238))))))),
	3898: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/signpost", [4,6,5,0], () => (__webpack_require__.e(5859).then(() => (() => (__webpack_require__(64200))))))),
	4613: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/selection-panels/radio", [4,6,5,0], () => (__webpack_require__.e(2089).then(() => (() => (__webpack_require__(60234))))))),
	6661: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/range", [4,6,5,0], () => (__webpack_require__.e(679).then(() => (() => (__webpack_require__(98453))))))),
	13988: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/password", [4,6,5,0], () => (__webpack_require__.e(8918).then(() => (() => (__webpack_require__(13750))))))),
	15323: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/modal", [4,6,5,0], () => (__webpack_require__.e(8247).then(() => (() => (__webpack_require__(68205))))))),
	17189: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/internal-components/panel", [4,6,5,0], () => (__webpack_require__.e(3234).then(() => (() => (__webpack_require__(47788))))))),
	19152: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/button-handle", [4,6,5,0], () => (__webpack_require__.e(3385).then(() => (() => (__webpack_require__(70802))))))),
	20076: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/button-expand", [4,6,5,0], () => (__webpack_require__.e(624).then(() => (() => (__webpack_require__(41296))))))),
	25131: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/card", [4,6,5,0], () => (__webpack_require__.e(5204).then(() => (() => (__webpack_require__(51634))))))),
	25492: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/breadcrumb", [4,6,5,0], () => (__webpack_require__.e(5969).then(() => (() => (__webpack_require__(817))))))),
	27076: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/internal-components/visual-checkbox", [4,6,5,0], () => (__webpack_require__.e(1608).then(() => (() => (__webpack_require__(56737))))))),
	27326: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/internal-components/split-handle", [4,6,5,0], () => (__webpack_require__.e(8410).then(() => (() => (__webpack_require__(92175))))))),
	28865: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/textarea", [4,6,5,0], () => (__webpack_require__.e(5926).then(() => (() => (__webpack_require__(49509))))))),
	34482: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/button-sort", [4,6,5,0], () => (__webpack_require__.e(2260).then(() => (() => (__webpack_require__(49701))))))),
	35183: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/toggle", [4,6,5,0], () => (__webpack_require__.e(7635).then(() => (() => (__webpack_require__(90215))))))),
	35617: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/divider", [4,6,5,0], () => (__webpack_require__.e(7887).then(() => (() => (__webpack_require__(40394))))))),
	42052: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/forms", [4,6,5,0], () => (__webpack_require__.e(6480).then(() => (() => (__webpack_require__(60240))))))),
	43457: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/grid", [4,6,5,0], () => (__webpack_require__.e(2733).then(() => (() => (__webpack_require__(74289))))))),
	44602: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/tree-view", [4,6,5,0], () => (__webpack_require__.e(9554).then(() => (() => (__webpack_require__(38847))))))),
	46756: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/time", [4,6,5,0], () => (__webpack_require__.e(5075).then(() => (() => (__webpack_require__(99743))))))),
	50454: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/selection-panels/checkbox", [4,6,5,0], () => (__webpack_require__.e(1423).then(() => (() => (__webpack_require__(10303))))))),
	53541: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/button-inline", [4,6,5,0], () => (__webpack_require__.e(8462).then(() => (() => (__webpack_require__(16356))))))),
	56913: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/pagination", [4,6,5,0], () => (__webpack_require__.e(1436).then(() => (() => (__webpack_require__(49045))))))),
	57403: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/test-dropdown", [4,6,5,0], () => (__webpack_require__.e(9506).then(() => (() => (__webpack_require__(82410))))))),
	69093: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/search", [4,6,5,0], () => (__webpack_require__.e(2461).then(() => (() => (__webpack_require__(50724))))))),
	71981: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/navigation", [4,6,5,0], () => (__webpack_require__.e(7533).then(() => (() => (__webpack_require__(72061))))))),
	76351: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/badge", [4,6,5,0], () => (__webpack_require__.e(2477).then(() => (() => (__webpack_require__(8437))))))),
	78426: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/accordion", [4,6,5,0], () => (__webpack_require__.e(7362).then(() => (() => (__webpack_require__(26690))))))),
	78658: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/input", [4,6,5,0], () => (__webpack_require__.e(2159).then(() => (() => (__webpack_require__(90472))))))),
	84700: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/date", [4,6,5,0], () => (__webpack_require__.e(4501).then(() => (() => (__webpack_require__(27217))))))),
	88426: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/internal-components/overlay", [4,6,5,0], () => (__webpack_require__.e(7313).then(() => (() => (__webpack_require__(13045))))))),
	88827: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/datalist", [4,6,5,0], () => (__webpack_require__.e(6818).then(() => (() => (__webpack_require__(79485))))))),
	88983: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/button-action", [4,6,5,0], () => (__webpack_require__.e(8326).then(() => (() => (__webpack_require__(28669))))))),
	89592: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/file", [4,6,5,0], () => (__webpack_require__.e(193).then(() => (() => (__webpack_require__(60677))))))),
	90387: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/dropdown", [4,6,5,0], () => (__webpack_require__.e(8923).then(() => (() => (__webpack_require__(63202))))))),
	91408: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/select", [4,6,5,0], () => (__webpack_require__.e(9713).then(() => (() => (__webpack_require__(4491))))))),
	92035: () => (loadSingletonVersionCheckFallback("default", "@cds/angular/internal-components/popup", [4,6,5,0], () => (__webpack_require__.e(6620).then(() => (() => (__webpack_require__(78566))))))),
	5284: () => (loadSingletonVersionCheckFallback("default", "@cds/core/internal", [4,6,5,0], () => (__webpack_require__.e(5479).then(() => (() => (__webpack_require__(85479))))))),
	45043: () => (loadSingletonVersionCheckFallback("default", "@cds/core/icon/icon.service.js", [4,6,5,0], () => (__webpack_require__.e(7468).then(() => (() => (__webpack_require__(84393))))))),
	98270: () => (loadSingletonVersionCheckFallback("default", "@cds/core/button-action", [4,6,5,0], () => (__webpack_require__.e(9056).then(() => (() => (__webpack_require__(64334))))))),
	85936: () => (loadSingletonVersionCheckFallback("default", "@cds/core/internal-components/panel", [4,6,5,0], () => (__webpack_require__.e(7997).then(() => (() => (__webpack_require__(5920))))))),
	94022: () => (loadSingletonVersionCheckFallback("default", "@cds/core/forms", [4,6,5,0], () => (__webpack_require__.e(262).then(() => (() => (__webpack_require__(95341))))))),
	99307: () => (loadSingletonVersionCheckFallback("default", "@cds/core/input", [4,6,5,0], () => (__webpack_require__.e(7332).then(() => (() => (__webpack_require__(15140))))))),
	37580: () => (loadSingletonVersionCheckFallback("default", "@cds/core/internal-components/popup", [4,6,5,0], () => (__webpack_require__.e(5420).then(() => (() => (__webpack_require__(18360))))))),
	38850: () => (loadSingletonVersionCheckFallback("default", "@cds/core/internal-components/overlay", [4,6,5,0], () => (__webpack_require__.e(3246).then(() => (() => (__webpack_require__(54092))))))),
	63531: () => (loadSingletonVersionCheckFallback("default", "@cds/core/polyfills", [4,6,5,0], () => (__webpack_require__.e(8825).then(() => (() => (__webpack_require__(48825))))))),
	6037: () => (loadSingletonVersionCheckFallback("default", "@cds/core/checkbox", [4,6,5,0], () => (__webpack_require__.e(9833).then(() => (() => (__webpack_require__(77455))))))),
	79063: () => (loadSingletonVersionCheckFallback("default", "@cds/core/radio", [4,6,5,0], () => (__webpack_require__.e(2257).then(() => (() => (__webpack_require__(98596))))))),
	87414: () => (loadSingletonVersionCheckFallback("default", "@cds/core/icon/register", [4,6,5,0], () => (__webpack_require__.e(9237).then(() => (() => (__webpack_require__(49910))))))),
	10799: () => (loadSingletonVersionCheckFallback("default", "devextreme-angular/core", [4,23,2,4], () => (__webpack_require__.e(4175).then(() => (() => (__webpack_require__(10988))))))),
	47530: () => (loadSingletonVersionCheckFallback("default", "devextreme/excel_exporter", [4,23,2,4], () => (__webpack_require__.e(6841).then(() => (() => (__webpack_require__(4828))))))),
	88450: () => (loadSingletonVersionCheckFallback("default", "devextreme/pdf_exporter", [4,23,2,4], () => (__webpack_require__.e(1605).then(() => (() => (__webpack_require__(40773))))))),
	96908: () => (loadSingletonVersionCheckFallback("default", "devextreme/localization", [4,23,2,4], () => (__webpack_require__.e(8355).then(() => (() => (__webpack_require__(43006))))))),
	67420: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/core/testing", [4,15,2,10], () => (__webpack_require__.e(1508).then(() => (() => (__webpack_require__(67239))))))),
	75033: () => (loadSingletonVersionCheckFallback("default", "@ngxs/store/internals", [4,3,8,2], () => (__webpack_require__.e(1501).then(() => (() => (__webpack_require__(6666))))))),
	17214: () => (loadSingletonVersionCheckFallback("default", "devextreme/events", [4,23,2,4], () => (__webpack_require__.e(6155).then(() => (() => (__webpack_require__(18827))))))),
	72757: () => (loadSingletonVersionCheckFallback("default", "devextreme/events/core/events_engine", [4,23,2,4], () => (() => (__webpack_require__(92223)))))
};
// no consumes in initial chunks
var chunkMapping = {
	"193": [
		4414,
		48850
	],
	"215": [
		5454,
		10360,
		48850
	],
	"234": [
		5454,
		48850,
		62782
	],
	"240": [
		5454,
		48850,
		75989
	],
	"248": [
		415,
		5284,
		25434,
		57966,
		95834
	],
	"262": [
		5284,
		98270
	],
	"303": [
		5454,
		48850,
		50768
	],
	"333": [
		5284,
		10439,
		37580
	],
	"355": [
		5284,
		19941,
		48678,
		87414
	],
	"394": [
		2772,
		5454,
		48850
	],
	"441": [
		5454,
		48850
	],
	"472": [
		5454,
		27771,
		48850
	],
	"479": [
		5284,
		75989,
		94022
	],
	"519": [
		5284
	],
	"619": [
		5284,
		45043,
		95834,
		98270
	],
	"624": [
		48850,
		57966
	],
	"677": [
		4414,
		5454,
		48850
	],
	"679": [
		5168,
		48850
	],
	"724": [
		5454,
		9420,
		48850
	],
	"802": [
		5454,
		48850,
		57660
	],
	"817": [
		5454,
		48850,
		89343
	],
	"842": [
		5284,
		27771,
		45043,
		57079,
		86699,
		95834,
		98270
	],
	"863": [
		5284,
		79063
	],
	"890": [
		5284,
		45043,
		95834,
		98270
	],
	"988": [
		5454,
		17214,
		48850,
		72757
	],
	"1032": [
		5284,
		45043,
		70344,
		75989,
		86699,
		94022,
		95834
	],
	"1117": [
		14113,
		48850
	],
	"1238": [
		5454,
		48850,
		69438
	],
	"1296": [
		5454,
		48850,
		57966
	],
	"1381": [
		5454
	],
	"1423": [
		48850,
		50768
	],
	"1436": [
		48850,
		58987
	],
	"1608": [
		415,
		48850
	],
	"1634": [
		5454,
		48850,
		54642
	],
	"1682": [
		5454,
		48850,
		86699
	],
	"1772": [
		48850,
		95087
	],
	"1798": [
		5284
	],
	"1953": [
		5284,
		75989,
		94022
	],
	"2061": [
		5454,
		48850,
		92209
	],
	"2079": [
		5454,
		48850
	],
	"2089": [
		48850,
		62782
	],
	"2094": [
		5284,
		26246,
		45043,
		70344,
		95834
	],
	"2159": [
		27771,
		48850
	],
	"2175": [
		5454,
		26246,
		48850
	],
	"2198": [
		5454,
		5812,
		10799,
		23974,
		33469,
		41171,
		47530,
		48850,
		72668,
		88450,
		96908
	],
	"2257": [
		94022
	],
	"2260": [
		48850,
		73041
	],
	"2410": [
		5454,
		48850,
		63516
	],
	"2428": [
		535,
		4501,
		5454,
		5812,
		8655,
		11489,
		22418,
		23974,
		33439,
		33469,
		34323,
		41171,
		48678,
		48850,
		72668,
		75243,
		85967,
		86699,
		87257,
		95834,
		96141,
		96795
	],
	"2461": [
		9420,
		48850
	],
	"2477": [
		28286,
		48850
	],
	"2672": [
		5284
	],
	"2733": [
		44585,
		48850
	],
	"3045": [
		5454,
		48850,
		53209
	],
	"3095": [
		5284,
		75989,
		94022
	],
	"3101": [
		2772,
		5284,
		45043,
		86699,
		95834
	],
	"3202": [
		5454,
		11278,
		48850
	],
	"3234": [
		48850,
		68686
	],
	"3346": [
		5454,
		48850,
		75022
	],
	"3385": [
		48850,
		57660
	],
	"3499": [
		19941,
		48850
	],
	"3626": [
		48850,
		75022
	],
	"3646": [
		5284
	],
	"3703": [
		5454,
		14113,
		48850
	],
	"3705": [
		5454,
		48850
	],
	"3750": [
		5454,
		43709,
		48850
	],
	"3848": [
		5284,
		95834
	],
	"3905": [
		5284,
		10439,
		37580
	],
	"4034": [
		5284
	],
	"4092": [
		5284
	],
	"4175": [
		17214,
		72757
	],
	"4200": [
		5454,
		48850,
		72612
	],
	"4236": [
		75033,
		96141
	],
	"4289": [
		5454,
		44585,
		48850
	],
	"4334": [
		5284
	],
	"4393": [
		5284
	],
	"4422": [
		5284,
		57966,
		95834
	],
	"4491": [
		5454,
		48850,
		57079
	],
	"4501": [
		42262,
		48850
	],
	"4543": [
		5284,
		45043,
		95834,
		98270
	],
	"4602": [
		5284,
		5454,
		5812,
		19941,
		33469,
		48678,
		48850,
		87414
	],
	"4657": [
		5284,
		45043,
		70344,
		75989,
		94022,
		95834,
		99307
	],
	"4678": [
		449,
		1344,
		2599,
		3898,
		4613,
		6661,
		11489,
		13988,
		15323,
		17189,
		19152,
		20076,
		25131,
		25492,
		27076,
		27326,
		28865,
		34482,
		35183,
		35617,
		42052,
		43457,
		44602,
		46756,
		50454,
		53541,
		56913,
		57403,
		69093,
		71981,
		75243,
		76351,
		78426,
		78658,
		84700,
		85967,
		88426,
		88827,
		88983,
		89592,
		90387,
		91408,
		92035
	],
	"4729": [
		5454,
		48850,
		95834
	],
	"4818": [
		5454,
		48850,
		95087
	],
	"4921": [
		10799,
		47530,
		88450,
		96908
	],
	"4934": [
		5454,
		5812,
		10799,
		48850
	],
	"4943": [
		48850,
		95834
	],
	"5043": [
		5454
	],
	"5075": [
		14614,
		48850
	],
	"5140": [
		5284,
		94022
	],
	"5204": [
		48850,
		54642
	],
	"5292": [
		5284,
		45043,
		70344,
		95834,
		98270
	],
	"5341": [
		5284,
		98270
	],
	"5420": [
		38850
	],
	"5479": [
		63531
	],
	"5646": [
		5284,
		19941,
		38850
	],
	"5859": [
		48850,
		72612
	],
	"5860": [
		5284
	],
	"5920": [
		5284
	],
	"5926": [
		19898,
		48850
	],
	"5969": [
		48850,
		89343
	],
	"6086": [
		535,
		4501,
		5454,
		5812,
		23974,
		33439,
		33469,
		41171,
		48850,
		85967,
		86699,
		87257,
		96141,
		96795
	],
	"6104": [
		48850,
		69438
	],
	"6209": [
		5284
	],
	"6288": [
		449,
		535,
		1344,
		2599,
		3898,
		4613,
		5454,
		6661,
		11489,
		13988,
		15323,
		17189,
		19152,
		20076,
		25131,
		25492,
		27076,
		27326,
		28865,
		33439,
		34482,
		35183,
		35617,
		42052,
		43457,
		44602,
		46756,
		50454,
		53541,
		56913,
		57403,
		69093,
		71981,
		75243,
		76351,
		78426,
		78658,
		84700,
		85967,
		88426,
		88827,
		88983,
		89592,
		90387,
		91408,
		92035
	],
	"6356": [
		5454,
		24742,
		48850
	],
	"6480": [
		48850,
		75989
	],
	"6620": [
		10439,
		48850
	],
	"6666": [
		5454
	],
	"6690": [
		5454,
		48850,
		59571
	],
	"6737": [
		415,
		5454,
		48850
	],
	"6818": [
		48850,
		67694
	],
	"6821": [
		535,
		4501,
		5454,
		5812,
		10799,
		23974,
		33439,
		33469,
		41171,
		48678,
		48850,
		67420,
		72668,
		84700,
		87257,
		95834,
		96795
	],
	"6938": [
		5284,
		45043,
		95834,
		98270
	],
	"7212": [
		5454,
		48850,
		75033,
		96141
	],
	"7217": [
		5454,
		42262,
		48850
	],
	"7239": [
		5454
	],
	"7313": [
		48850,
		53209
	],
	"7331": [
		5284,
		19941,
		45043,
		86699,
		95834
	],
	"7362": [
		48850,
		59571
	],
	"7446": [
		5454,
		19941,
		48850
	],
	"7455": [
		94022
	],
	"7533": [
		48850,
		92209
	],
	"7635": [
		10360,
		48850
	],
	"7695": [
		5284,
		57966,
		75989,
		94022,
		99307
	],
	"7707": [
		5284,
		45043,
		95834
	],
	"7741": [
		5284,
		45043,
		70344,
		75989,
		94022,
		95834,
		99307
	],
	"7788": [
		5454,
		48850,
		68686
	],
	"7807": [
		5284,
		75989,
		94022
	],
	"7854": [
		5284,
		45043,
		70344,
		75989,
		94022,
		95834,
		99307
	],
	"7887": [
		2772,
		48850
	],
	"7953": [
		10799,
		67420,
		84700
	],
	"7959": [
		5284
	],
	"7962": [
		5284,
		45043
	],
	"8111": [
		5284,
		85936
	],
	"8125": [
		48850,
		86699
	],
	"8172": [
		25434,
		48850
	],
	"8177": [
		5284
	],
	"8205": [
		5454,
		48850,
		88217
	],
	"8247": [
		48850,
		88217
	],
	"8326": [
		48850,
		70344
	],
	"8360": [
		5284,
		38850
	],
	"8410": [
		26246,
		48850
	],
	"8437": [
		5454,
		28286,
		48850
	],
	"8449": [
		5454,
		25434,
		48850
	],
	"8453": [
		5168,
		5454,
		48850
	],
	"8462": [
		24742,
		48850
	],
	"8566": [
		5454,
		10439,
		48850
	],
	"8596": [
		5284,
		94022
	],
	"8667": [
		5284
	],
	"8669": [
		5454,
		48850,
		70344
	],
	"8679": [
		10799
	],
	"8847": [
		5454,
		48850,
		70226
	],
	"8856": [
		5284
	],
	"8898": [
		5284,
		25434,
		45043,
		95834
	],
	"8918": [
		43709,
		48850
	],
	"8923": [
		11278,
		48850
	],
	"8963": [
		5284,
		6037
	],
	"9045": [
		5454,
		48850,
		58987
	],
	"9422": [
		5284,
		45043,
		70344,
		75989,
		94022,
		95834,
		99307
	],
	"9485": [
		5454,
		48850,
		67694
	],
	"9506": [
		48850,
		63516
	],
	"9509": [
		5454,
		19898,
		48850
	],
	"9554": [
		48850,
		70226
	],
	"9695": [
		5284,
		19941,
		38850,
		53209
	],
	"9701": [
		5454,
		48850,
		73041
	],
	"9713": [
		48850,
		57079
	],
	"9743": [
		5454,
		14614,
		48850
	],
	"9803": [
		5284,
		57966,
		75989,
		94022,
		99307
	],
	"9811": [
		5284,
		75989,
		94022
	],
	"9833": [
		94022
	],
	"9837": [
		5284,
		75989,
		94022
	],
	"9910": [
		5284
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
		});
	}
}